import { createAction, props } from '@ngrx/store';
import { ConnectionQueryInput } from '../../../shared/data/inputs/connection-query.input';
import { UserConnectionQueryModel } from '../../../shared/data/models/user-connection-query.model';
import { ConnectionErrorInput } from '../../../shared/data/inputs/connection-error.input';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { GetGroupMembersInput } from '../../../shared/data/inputs/get-group-members.input';
import { SearchUsersInputs } from '../../../shared/data/inputs/search-users.inputs';
import { PeopleToFollowInput } from '../../../shared/data/inputs/people-to-follow.input';

export const loadPeopleToFollow = createAction(
  '[PeopleToFollow] Load people to follow',
  props<{ input?: PeopleToFollowInput }>()
);

/*
 *  loading user connections
 */
export const loadUserConnectionFollowing = createAction(
  '[UserConnections] Load User Connection Following',
  props<{ payload: ConnectionQueryInput }>()
);

export const loadUserConnectionFollowers = createAction(
  '[UserConnections] Load User Connection Followers',
  props<{ payload: ConnectionQueryInput }>()
);

export const loadUserConnectionMutual = createAction(
  '[UserConnections] Load User Connection Mutual',
  props<{ payload: ConnectionQueryInput }>()
);

export const searchUsers = createAction(
  '[UserConnections] search for users',
  props<{ payload: SearchUsersInputs }>()
);

export const loadGroupMembers = createAction(
  '[UserConnections] Load group members',
  props<{ payload: GetGroupMembersInput }>()
);

export const loadMoreGroupMembers = createAction(
  '[UserConnections] Load more group members',
  props<{ payload: GetGroupMembersInput }>()
);

export const loadUserConnectionSuccess = createAction(
  '[UserConnections] Load User Connection Success',
  props<{ payload: UserConnectionQueryModel }>()
);

export const loadUserConnectionError = createAction(
  '[UserConnections] Load User Connection Error',
  props<{ payload: ConnectionErrorInput }>()
);

// follow and unFollow logic
export const followUserConnection = createAction(
  '[UserConnections] Follow User Connection',
  props<{ payload: FollowUnFollowUserInput }>()
);

export const unFollowUserConnection = createAction(
  '[UserConnections] UnFollow User Connection',
  props<{ payload: FollowUnFollowUserInput }>()
);

export const followUnFollowUserConnectionSuccess = createAction(
  '[UserConnections] Follow UnFollow User Connection Success',
  props<{ payload: MiniUserModel }>()
);

export const followUnFollowUserConnectionError = createAction(
  '[UserConnections] Follow UnFollow User Connection Error',
  props<{ payload: ConnectionErrorInput }>()
);

// load more connections

export const loadMorePeopleToFollow = createAction(
  '[PeopleToFollow] Load more people to follow',
  props<{ input?: PeopleToFollowInput }>()
);

export const loadMoreUserConnectionFollowing = createAction(
  '[UserConnections] Load More User Connection Following',
  props<{ payload: ConnectionQueryInput }>()
);

export const loadMoreUserConnectionFollowers = createAction(
  '[UserConnections] Load  More User Connection Followers',
  props<{ payload: ConnectionQueryInput }>()
);

export const loadMoreUserConnectionMutual = createAction(
  '[UserConnections] Load More User Connection Mutual',
  props<{ payload: ConnectionQueryInput }>()
);

export const loadMoreUserConnectionSuccess = createAction(
  '[UserConnections] Load More User Connection Success',
  props<{ payload: UserConnectionQueryModel }>()
);
